.overlayLayer {
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 2147483647;
}

.componentBox {
  position: absolute;
  box-sizing: border-box;
}

.componentLabel {
  position: absolute;
  top: 0;
  left: 0;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.4;
  white-space: nowrap;
  border-radius: 0 0 4px 0;
  color: #ffffff;
  max-width: 320px;
  overflow: hidden;
  text-overflow: ellipsis;
}
